import { getPath } from '@/router/common'

const baseUrl = {
  title: '快递出入仓',
  path: 'printbq'
}

export default [
  {
    path: getPath('warehousingbq', baseUrl),
    name: 'WareHousingBQ',
    component: () => import(/* webpackChunkName: "WareHousingBQ" */ '@/views/printbq/warehousingbq/index.vue'),
    meta: {
      title: '出入仓明细'
    }
  },
  {
    path: getPath('tydindex', baseUrl),
    name: 'tydindex',
    component: () => import(/* webpackChunkName: "tydindex" */ '@/views/printbq/tydindex/index.vue'),
    meta: {
      title: '打开托运单打印'
    }
  },
  {
    path: getPath('index', baseUrl),
    name: 'printbqIndex',
    component: () => import(/* webpackChunkName: "printbqIndex" */ '@/views/printbq/index/index.vue'),
    meta: {
      title: '打开标签打印弹窗'
    }
  },
  {
    path: getPath('batchPrintUnits', baseUrl),
    name: 'printbq_batchPrintUnits',
    component: () => import(/* webpackChunkName: "printbq_batchPrintUnits" */ '@/views/printbq/batchPrintUnits/index.vue'),
    meta: {
      title: '批量打印运单'
    }
  },
  {
    path: getPath('quickPrintbq', baseUrl),
    name: 'printbq_quickPrintbq',
    component: () => import(/* webpackChunkName: "printbq_quickPrintbq" */ '@/views/printbq/quickPrintbq/index.vue'),
    meta: {
      title: '快速打印标签'
    }
  },
  {
    path: getPath('batchPrePrintbq', baseUrl),
    name: 'printbq_batchPrePrintbq',
    component: () => import(/* webpackChunkName: "printbq_batchPrePrintbq" */ '@/views/printbq/batchPrePrintbq/index.vue'),
    meta: {
      title: '批量预打印托运单'
    }
  },
  {
    path: getPath('batchPrePrintbqAddOrEdit', baseUrl),
    name: 'printbq_batchPrePrintbqAddOrEdit',
    component: () => import(/* webpackChunkName: "printbq_batchPrePrintbqAddOrEdit" */ '@/views/printbq/batchPrePrintbqAddOrEdit/index.vue'),
    meta: {
      title: '新增修改'
    }
  },
  {
    path: getPath('printChildUnit', baseUrl),
    name: 'printbq_printChildUnit',
    component: () => import(/* webpackChunkName: "printbq_printChildUnit" */ '@/views/printbq/printChildUnit/index.vue'),
    meta: {
      title: '打印标签'
    }
  },
  {
    path: getPath('quickPrintbqAddOrEdit', baseUrl),
    name: 'printbq_quickPrintbqAddOrEdit',
    component: () => import(/* webpackChunkName: "printbq_quickPrintbqAddOrEdit" */ '@/views/printbq/quickPrintbqAddOrEdit/index.vue'),
    meta: {
      title: '新增修改'
    }
  },
  {
    path: getPath('QtyDetail', baseUrl),
    name: 'printbq_QtyDetail',
    component: () => import(/* webpackChunkName: "printbq_QtyDetail" */ '@/views/printbq/qtyDetail/index.vue'),
    meta: {
      title: '条形码/包装规格'
    }
  }
]
